<template>
  <!-- 系统目录 西药目录 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!--        <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>-->
        <!-- tit -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 状态下拉 -->
            <div class="main-icon-b" style="margin-right: 20px;">
              <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
              <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
                <span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a" dropdown>全部</el-dropdown-item>
                  <el-dropdown-item command="b">启用</el-dropdown-item>
                  <el-dropdown-item command="c">禁用</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- 搜索框 -->
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.deptName" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <!-- 按钮组（直接跟在时间选择器后面） -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  v-if="$store.getters.hasPermission('system:dept:add')"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border size="mini" @row-dblclick="handleShowDept">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead" align="center"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="148"
                             v-if="$store.getters.hasPermission('system:dept:edit')">
              <template #default="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" size="mini" @click="handleEditDept(scope.row)">编辑</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
                class="fixed-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[8, 10, 20]"
                :page-size="pageSize"
                :total="totalSize"
                layout="total, sizes, prev, pager, next, jumper"
                background
                style="margin-top: 10px;">
            </el-pagination>
          </div>
        </div>

        <el-dialog
            :title="showDeptDialogVisible ? '查看科室档案' : addDeptForm.id ? '修改科室档案' : '新增科室档案'"
            :visible.sync="addDeptDialogVisible"
            :close-on-click-modal="false"
            width="50%"
            @close="handleCloseAddDeptForm"
        >
          <!-- 使用 Element UI 的布局组件 -->
          <el-row :gutter="24">
            <!-- 左侧表单区域 -->
            <el-col :span="24">
              <el-card shadow="never" class="form-card">
                <div slot="header" class="clearfix">
                  <span>基本信息</span>
                </div>
                <el-form ref="addDeptForm" :model="addDeptForm" :rules="addDeptFormRules" label-width="100px"
                         size="mini" :disabled="showDeptDialogVisible">
                  <!-- 第一行：编码 + 有效状态 -->
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="编码：" prop="deptCode">
                        <el-input ref="deptCodeInput" v-model="addDeptForm.deptCode" disabled/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="有效状态：" prop="status" required>
                        <el-select v-model="addDeptForm.status" placeholder="请选择" style="width: 100%">
                          <el-option v-for="option in statusOptions" :key="option.id" :label="option.label"
                                     :value="option.id"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- 第二行：科室名称 + 拼音简码 -->
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="科室名称：" prop="deptName" required>
                        <el-input v-model="addDeptForm.deptName" placeholder="请输入内容"
                                  @input="handleInputTurnPyCode"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="拼音简码：">
                        <el-input v-model="addDeptForm.pyCode" placeholder="请输入拼音简码" disabled/>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- 第三行：负责人 + 负责人电话 -->
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="负责人：" prop="personInCharge">
                        <el-select v-model="addDeptForm.personInCharge" placeholder="请选择" style="width: 100%">
                          <el-option v-for="option in fzrOptions" :key="option.id" :label="option.label"
                                     :value="option.id"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="负责人电话：" prop="personInChargeTel">
                        <el-input v-model="addDeptForm.personInChargeTel" placeholder="请输入内容"/>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- 第四行：科室专业 + 物理位置 -->
                  <!--                  <el-row :gutter="20">
                                      <el-col :span="12">
                                        <el-form-item label="科室专业：" prop="specialtyCode">
                                          <el-select v-model="addDeptForm.specialtyCode" placeholder="请选择" style="width: 100%">
                                            <el-option v-for="option in specialtyNameOptions" :key="option.id" :label="option.label"
                                                       :value="option.id"/>
                                          </el-select>
                                        </el-form-item>
                                      </el-col>
                  &lt;!&ndash;                    <el-col :span="12">
                                        <el-form-item label="物理位置：" prop="physicalPosition">
                                          <el-cascader
                                              size="mini"
                                              ref="physicalPositionRef"
                                              prop="physicalPositionArr"
                                              :key="addressKey"
                                              v-model="physicalPositionArr"
                                              :props="addressProps"
                                              :options="provinces"
                                              @visible-change="handleCascaderVisible"
                                              :placeholder="physicalPosition"
                                              style="width: 100%; margin-bottom: 4px;"
                                          />
                                        </el-form-item>
                                      </el-col>&ndash;&gt;
                                    </el-row>-->

                  <!-- 第五行：返诊期限 + 隶属诊所 -->
                  <el-row :gutter="20">
                    <el-col :span="12">

                      <el-form-item label="科室专业：" prop="specialtyCode">
                        <el-select v-model="addDeptForm.specialtyCode" placeholder="请选择" style="width: 100%">
                          <el-option v-for="option in specialtyNameOptions" :key="option.id" :label="option.label"
                                     :value="option.id"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="返诊期限：" prop="returnVisitNum">
                        <el-input-number :min="0" :max="365" v-model="addDeptForm.returnVisitNum"
                                         placeholder="请输入返诊期限" style="width: 100%"/>
                      </el-form-item>
                    </el-col>
                    <!--                    <el-col :span="12">
                                          <el-form-item label="隶属诊所：" prop="institutionId">
                                            <el-select v-model="addDeptForm.institutionId" placeholder="请选择" style="width: 100%">
                                              <el-option v-for="option in clinicOptions" :key="option.id" :label="option.label"
                                                         :value="option.id"/>
                                            </el-select>
                                          </el-form-item>
                                        </el-col>-->
                  </el-row>

                  <!-- 第六行：科室类型 + 医学类型 -->
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="科室类型：" prop="deptType">
                        <el-select v-model="addDeptForm.deptType" placeholder="请选择" style="width: 100%">
                          <el-option v-for="option in deptTypeOptions" :key="option.id" :label="option.label"
                                     :value="option.id"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="医学类型：" prop="medicineType">
                        <el-select v-model="addDeptForm.medicineType" placeholder="请选择" style="width: 100%">
                          <el-option v-for="option in medicineTypeOptions" :key="option.id" :label="option.label"
                                     :value="option.id"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- 第七行：备注 -->
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="备注：" prop="remark">
                        <el-input
                            v-model="addDeptForm.remark"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入内容"

                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-card>
            </el-col>

            <!-- 右侧表格区域 -->
            <!--            <el-col :span="10">
                          <el-card shadow="never" class="table-card">
                            <div slot="header" class="clearfix">
                              <span>科室属性</span>
                              <el-button
                                  style="float: right; padding: 3px 0"
                                  type="text"
                                  icon="el-icon-plus"
                                  @click="addDeptAttributeDialog = true"
                                  :disabled="showDeptDialogVisible"
                              >
                                新增
                              </el-button>
                            </div>

                            <el-table
                                :data="addDeptForm.departmentAttribute"
                                border
                                size="mini"
                                empty-text="暂无数据"
                                :key="tableKey"
                            >
                              <el-table-column
                                  v-for="(col, inx) in tableRows2"
                                  :key="inx"
                                  :prop="col.prop"
                                  :label="col.name"
                                  :render-header="labelHead" align="center"
                                  :min-width="getColumnWidth(col.label,col.prop,addDeptForm.departmentAttribute)"
                              >
                                <template #default="{ row }">
                                  {{ safeGetMappedValue(col, row) }}
                                </template>
                              </el-table-column>
                              <el-table-column label="操作" width="80" align="center" v-if="!showDeptDialogVisible">
                                <template slot-scope="scope">
                                  <el-button type="text" size="mini" @click="editFormValue(scope.row,scope.$index)"
                                             icon="el-icon-edit" :disabled="showDeptDialogVisible"></el-button>
                                  <el-button type="text" size="mini" @click="handleDelete(scope.$index)" style="color: #F56C6C;"
                                             icon="el-icon-delete" :disabled="showDeptDialogVisible">
                                  </el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </el-card>
                        </el-col>-->
          </el-row>

          <!-- 新增属性模态框 -->
          <el-dialog
              title="新增科室属性"
              :visible.sync="addDeptAttributeDialog"
              width="40%"
              :close-on-click-modal="false"
              append-to-body
          >
            <el-form
                ref="deptAttributeForm"
                :model="deptAttributeForm"
                :rules="attributeRules"
                label-width="100px"
                size="mini"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="科室属性：" prop="attributeCode">
                    <el-select
                        v-model="deptAttributeForm.attributeCode"
                        placeholder="请选择"
                        style="width: 100%"
                    >
                      <el-option
                          v-for="option in selectKsOptions"
                          :key="option.id"
                          :label="option.label"
                          :value="option.id"
                          :disabled="isAttributeDisabled(option.id)"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="急诊：" prop="applyEmergency">
                    <el-select
                        v-model="deptAttributeForm.applyEmergency"
                        placeholder="请选择"
                        style="width: 100%"
                    >
                      <el-option
                          v-for="option in emeOptions"
                          :key="option.id"
                          :label="option.label"
                          :value="option.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="挂号：" prop="applyRegister">
                    <el-select
                        v-model="deptAttributeForm.applyRegister"
                        placeholder="请选择"
                        style="width: 100%"
                    >
                      <el-option
                          v-for="option in regOptions"
                          :key="option.id"
                          :label="option.label"
                          :value="option.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="门诊：" prop="applyOutpatient">
                    <el-select
                        v-model="deptAttributeForm.applyOutpatient"
                        placeholder="请选择"
                        style="width: 100%"
                    >
                      <el-option
                          v-for="option in OutOptions"
                          :key="option.id"
                          :label="option.label"
                          :value="option.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button size="mini" @click="handleCloseAddDeptAttributeForm">取消</el-button>
              <el-button type="primary" size="mini" @click="handleAddDeptAttribute">确定</el-button>
            </div>
          </el-dialog>

          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="handleAddDeptForm" v-if="!showDeptDialogVisible">保存
            </el-button>
            <el-button size="mini" @click="handleCloseAddDeptForm">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import SupplierAddDialog from './dept/addDialogVisible.vue';
// 接口
// import { getDeptList, updateSupplierEntity }  from "@/api/supplier.js";
import {addDept, docclinicList, getDeptAttribute, getDeptList, getDeptName, updateDept} from "@/api/ks/ks.js";
import {yglist} from "@/api/staff/staff.js";
import {getArea} from "@/api/reservation/reservation";
import {pinyin} from "pinyin-pro";
import dayjs from "dayjs";
import {mapGetters} from "vuex";
import {loadVuexModule} from "@/untils/db";
import {findAttribute} from "@/api/systemCatalogue/traMedici";

export default {
  components: {
    SupplierAddDialog
  },
  data() {
    return {
      provinces: [],
      addressKey: 0,
      addressProps: {
        lazy: true,
        value: 'areaCode',
        label: 'areaName',
        emitPath: true,
        leaf: node => node.areaLevel >= 5,
        lazyLoad: async (node, resolve) => {
          try {
            const level = node.level + 1;

            // 限制最大层级为5
            if (level > 5) {
              return resolve([]);
            }

            // 请求参数
            const params = {
              areaCode: node.level > 0 ? node.data.areaCode : undefined,
              areaLevel: level,
              condtion: ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'][level - 1]
            };

            const res = await getArea(params);
            const responseData = res?.data || [];

            // 如果没有数据，关闭下拉框
            if (responseData.length === 0 && level > 1) {

            }

            // 格式化数据（关键修改：添加 isLeaf 和 level 属性）
            const formattedData = responseData.map(item => ({
              ...item,
              value: item.areaCode, // 严格模式需要 value 字段
              label: item.areaName,
              level: level, // 标记当前层级
              isLeaf: level >= 5 // 第五级强制设为叶子节点
            }));

            resolve(formattedData);

          } catch (error) {
            console.error('加载地区数据失败:', error);
            resolve([]);
          }
        }
      },
      physicalPositionArr: [],
      physicalPosition: '',

      showDeptDialogVisible: false,
      addDeptAttributeDialog: false,
      addDeptDialogVisible: false,
      queryConditionForm: {
        deptName: '',
        status: null,
      },
      editingIndex: -1, // 当前编辑的索引
      isEditing: false, // 是否处于编辑模式
      addDeptForm: {
        id: null,
        deptCode: dayjs().format('YYYYMMDDHHmmss'),  //科室编码
        status: 1,  //有效状态
        deptName: '',  //科室名称
        pyCode: '',  //拼音简码
        personInCharge: '',  //负责人
        personInChargeTel: '',  //负责人电话
        specialtyName: '',  //科室专业
        physicalPosition: '',//物理位置
        returnVisitNum: null,  //返诊期限
        deptType: null,  //科室类型
        medicineType: null,  //医学类型
        remark: '',  //备注
        operatingUser: null,// 操作人
        clinicId: 0,// 所属诊所
        // 科室属性
        departmentAttribute: [],
        institutionId: null,
      },
      tableKey: 0,
      addDeptFormRules: {
        status: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        deptName: [
          {required: true, message: ' ', trigger: 'blur'},
          {min: 1, max: 100, message: '科室名称长度在 1 到 100 个字符', trigger: 'blur'}
        ],
        /*personInCharge: [
          {required: true, message: ' ', trigger: 'change'}
        ],*/
        personInChargeTel: [
          {pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/, message: '请输入正确的手机号或电话号码', trigger: 'blur'}
        ],
        specialtyName: [
          {required: true, message: ' ', trigger: 'change'}
        ],

        returnVisitNum: [
          {pattern: /^\d+$/, message: ' ', trigger: 'blur'},
          {validator: this.validateReturnVisitNum, trigger: 'blur'}
        ],
        /*institutionId: [
          {required: true, message: ' ', trigger: 'change'}
        ],*/
        /*deptType: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        medicineType: [
          {required: true, message: ' ', trigger: 'change'}
        ],*/
      },

      sexOptions: [{id: 1, label: '男', value: '男'}, {id: 2, label: '女', value: '女'}],
      YNOptions: [{id: 0, label: '是', value: '是'}, {id: 1, label: '否', value: '否'}],
      statusOptions: [{id: 1, label: '可用', value: '可用'}, {id: 0, label: '禁用', value: '禁用'}],
      clinicOptions: [], // 隶属诊所
      fzrOptions: [], // 负责人
      specialtyNameOptions: [],
      deptTypeOptions: [
        {id: 1, label: '临床科室'}, {id: 2, label: '检查科室'},
        {id: 3, label: '检验科室'}, {id: 4, label: '职能科室'},
        {id: 5, label: '财务科室'}
      ],
      medicineTypeOptions: [
        {id: 1, label: '西医', value: '西医'}, {id: 2, label: '中医', value: '中医'}, {
          id: 3,
          label: '民族医',
          value: '民族医'
        },
        {id: 4, label: '中西医结合', value: '中西医结合'}, {id: 5, label: '其它', value: '其它'}
      ],
      deptAttributeForm: {
        attributeCode: null,
        applyEmergency: null,
        applyRegister: null,
        applyOutpatient: null
      },
      attributeRules: {
        attributeCode: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        applyEmergency: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        applyRegister: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        applyOutpatient: [
          {required: true, message: ' ', trigger: 'change'}
        ]
      },

      selectKsOptions: [
        {id: 0, label: '麻醉', value: '麻醉'},
        {id: 1, label: '临床', value: '临床'},
        {id: 2, label: '治疗', value: '治疗'},
        {id: 3, label: '财务', value: '财务'}
      ],
      emeOptions: [
        {id: 0, label: '否', value: '否'},
        {id: 1, label: '是', value: '是'}
      ],
      regOptions: [
        {id: 0, label: '否', value: '否'},
        {id: 1, label: '是', value: '是'}
      ],
      OutOptions: [
        {id: 0, label: '否', value: '否'},
        {id: 1, label: '是', value: '是'}
      ],
      HosOptions: [
        {id: 0, label: '否', value: '否'},
        {id: 1, label: '是', value: '是'}
      ],
      tableRows2: [
        {name: "属性", prop: "attributeCode", type: "", op: 'selectKsOptions'},
        {name: "急诊", prop: "applyEmergency", type: "", op: 'emeOptions'},
        {name: "门诊", prop: "applyOutpatient", type: "", op: 'regOptions'},
        {name: "挂号", prop: "applyRegister", type: "", op: 'OutOptions'},
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // str
      toCode: '',
      treeValue: '',
      tableHeight: '570', // table的高度，以便超出高度显示滚动条
      currentHeight: '', // 用于计算table的高度，以便超出高度显示滚动条
      windowWidth: '', //表格自适应宽度
      searchValue: '',
      CatalogueName: '科室档案',
      DropDownedName: '全部',
      iconComes: 'el-icon-xy',
      // boolean
      loading: false,
      disabled: true,
      // number
      ydNameId: 0,
      pageNum: 1, //当前页currentPage
      pageSize: 8,
      totalSize: 10, //总条数
      pageSizeSave: 0,
      // arr
      form: {},
      editform: {},
      res: [],
      NameOptions: [],
      restaurants: [], // 搜索关键字
      // title右侧按钮
      headerBtn: [
        {search: "search", title: "搜索", type: "success", style: {marginLeft: "-20px"}},
        {add: "add", title: "新增", type: "warning"},
      ],
      // 页面默认按钮// 基础按钮配置（始终显示）
      defaultButtons: [
        // { title:"新增西成药",icon:"el-icon-adds", type:"primary" },
        {title: "新增", icon: "el-icon-adds", type: "success"},
        {title: "修改", icon: "el-icon-edit", type: "warning"},
        {title: "查看", icon: "el-icon-watch", type: "primary"},
        // { title:"删除",icon:"el-icon-del", type:"danger" },
        // { title:"目录引用",icon:"el-icon-closeFiles", type:"primary" },
        {title: "打印", icon: "el-icon-ggml", type: "primary"},
        {title: "导出", icon: "el-icon-export", type: "primary"},
        {title: "关闭", icon: "el-icon-close", type: "primary"},
      ],
      // 最终使用的按钮数组
      feetBtn: [],
      // tableRows
      tableRows: [
        {name: "科室编码", prop: "deptCode"},
        {name: "科室名称", prop: "deptName"},
        {name: "拼音简码", prop: "pyCode"},
        {
          name: "医学类型",
          prop: "medicineType",
          op: 'medicineTypeOptions'
        },
        {
          name: "科室类型",
          prop: "deptType",
          op: 'deptTypeOptions'
        },
        {
          name: "负责人",
          prop: "personInCharge",
          op: 'fzrOptions'
        },
        {name: "联系电话", prop: "personInChargeTel"},
        {name: "操作时间", prop: "operatingTime"},
        {name: "备注", prop: "remark"}
      ],
      elTree: [
        {
          label: '全部', path: '', title: '', icon: 'el-icon-news',
          children: [
            {id: 1, label: '药库', path: '', title: '药库', icon: 'el-icon-xy'},
            {id: 2, label: '物资', path: '', title: '物资', icon: 'el-icon-zhongchengyao'},
            {id: 3, label: '设备', path: '', title: '设备', icon: 'el-icon-zhongcaoyao'},
            {id: 4, label: '材料', path: '', title: '材料', icon: 'el-icon-xyzp'},
            {id: 5, label: '固定资产', path: '', title: '固定资产', icon: 'el-icon-xyjhtxyyzhy'},
          ],
        },
      ],
      tableData: [],
      currentTable: [],
      // props
      // 医学类型映射
      medicineTypeMap: {
        1: '西药',
        2: '中成药',
        3: '中药',
        4: '卫材',
        5: '设备',
        6: '材料',
        7: '固定资产'
      },
      deptTypeMap: {
        1: '临床科室',
        2: '检查科室',
        3: '检验科室',
        4: '职能科室',
        5: '财务科室',
      },
      // 负责人映射表
      personInChargeMap: {},
      userInfo: {},
    };
  },
  async mounted() {
    await this.loadData();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.addDeptForm.institutionId = this.userInfo.clinicId
    this.fzrOptions = this.$store.getters['preload/getEmployeeOptions'];
    this.specialtyNameOptions = this.$store.getters['preload/getDepartmentSpecialtyOptions'];
    this.clinicOptions = this.$store.getters['preload/getClinicListOptions'].filter(clinic => clinic.id === this.userInfo.clinicId)
    this.getDeptList();
  },
  methods: {
    isAttributeDisabled(attributeId) {
      const currentEditingId = this.isEditing ? this.deptAttributeForm.attributeCode : null;
      return this.addDeptForm.departmentAttribute.some(item =>
          item.attributeCode === attributeId && item.attributeCode !== currentEditingId
      );
    },
    async handleShowDept(row) {
      let res = await getDeptAttribute({deptId: row.id});
      if (res.code === 200) {
        this.addDeptForm = res.data;
        this.physicalPositionArr = JSON.parse(res.data.physicalPosition);
        await this.loadSelectedPath();
        this.showDeptDialogVisible = true;
        this.addDeptDialogVisible = true;
      } else {
        this.$message.warning(res.message);
      }
    },
    async handleEditDept(row) {
      let res = await getDeptAttribute({deptId: row.id});
      if (res.code === 200) {
        this.addDeptForm = res.data;
        this.physicalPositionArr = JSON.parse(res.data.physicalPosition);
        await this.loadSelectedPath();
        this.addDeptDialogVisible = true;
      } else {
        this.$message.warning(res.message);
      }
    },
    async getClinicList() {
      let res = await docclinicList();
      this.clinicOptions = res.data.filter(clinic => clinic.id === this.userInfo.clinicId)
          .map(item => {
            return {id: item.id, label: item.name}
          });
    },
    async getDepartmentSpecialty() {
      let res = await getDeptName();
      // 修改这里：返回包含 code 和 id 的完整对象
      this.specialtyNameOptions = res.data.map(item => {
        return {id: item.id, label: item.name}
      });
    },

    // 触发员工信息选择
    async getEmployee() {
      // 员工信息数据源
      const res = await yglist();
      this.fzrOptions = res.data.map(item => {
        return {id: item.id, label: item.fullName}
      });
    },
    handleInputTurnPyCode() {
      this.addDeptForm.pyCode = pinyin(this.addDeptForm.deptName, {
        pattern: 'first',
        toneType: 'none',
        separator: ''
      }).toLocaleUpperCase();
    },
    validateReturnVisitNum(rule, value, callback) {
      if (value === '') {
        callback()
      } else if (!/^\d+$/.test(value)) {
        callback(new Error('返诊期限必须为数字'))
      } else if (value < 0) {
        callback(new Error('返诊期限不能为负数'))
      } else if (value > 365) {
        callback(new Error('返诊期限不能超过365天'))
      } else {
        callback()
      }
    },
    async loadSelectedPath() {
      try {
        // 1. 确保省级数据已加载
        if (this.provinces.length === 0) {
          await this.loadProvincial();
        }

        // 2. 检查数据有效性
        if (!this.physicalPositionArr || !Array.isArray(this.physicalPositionArr) || this.physicalPositionArr.length === 0) {
          console.log('地址数据为空，无需回显');
          return;
        }

        const codes = [...this.physicalPositionArr]; // 创建副本避免引用问题
        console.log('开始加载地址路径:', codes);

        // 3. 定义各级请求条件
        const levelConditions = ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'];
        let currentNodes = this.provinces;
        const loadedCodes = [];
        const addressNames = [];

        // 4. 按层级逐级加载
        for (let i = 0; i < codes.length; i++) {
          const code = codes[i];
          const level = i + 1;

          let targetNode = currentNodes.find(node => node.areaCode === code);

          // 如果未找到，动态加载该级数据
          if (!targetNode) {
            const parentCode = i > 0 ? codes[i - 1] : undefined;
            const params = {
              areaCode: parentCode,
              areaLevel: level,
              condtion: levelConditions[i]
            };
            const res = await getArea(params);
            const newNodes = res.data || [];
            currentNodes = newNodes;
            targetNode = newNodes.find(node => node.areaCode === code);

            // 更新省级数据缓存
            if (level === 1) {
              this.provinces = newNodes;
            }
          }

          if (!targetNode) {
            console.warn(`未找到地址编码: ${code}, 层级: ${level}`);
            break;
          }

          loadedCodes.push(code);
          addressNames.push(targetNode.areaName);

          // 动态加载下一级数据
          if (level < 5 && level < codes.length) {
            if (!targetNode.children || targetNode.children.length === 0) {
              const nextLevelParams = {
                areaCode: code,
                areaLevel: level + 1,
                condtion: levelConditions[level]
              };
              const res = await getArea(nextLevelParams);
              targetNode.children = res.data || [];
            }
            currentNodes = targetNode.children || [];
          }
        }

        // 5. 使用更可靠的DOM更新策略
        await this.$nextTick();

// 先更新显示文本
        this.physicalPosition = addressNames.join('/') || '请选择地址';
// 更新数组值 - 直接赋值，不强制刷新
        this.physicalPositionArr = [...loadedCodes];
      } catch (error) {
        console.error('加载地址路径失败:', error);
      }
    },
    async loadProvincial() {
      try {
        const res = await getArea({areaLevel: 1, condtion: 'area_p_code'});
        this.provinces = res.data.map(item => ({
          areaCode: item.areaCode,
          areaName: item.areaName,
          areaLevel: 1,
          leaf: false,
        }));
      } catch (error) {
        console.error('加载省级数据失败:', error);
      }
    },
    async initAddressData() {
      try {
        // 确保省级数据已加载
        if (this.provinces.length === 0) {
          await this.loadProvincial();
        }

        this.physicalPositionArr = this.physicalPositionArr || [];

        // 如果存在有效编码才加载路径
        if (this.physicalPositionArr.length > 0) {
          await this.loadSelectedPath();
        }
      } catch (error) {
        console.error('地址初始化失败:', error);
      }
    },
    handleCascaderVisible(visible) {
      if (visible) {
        // 当下拉框打开时才初始化数据
        this.initAddressData();
      }
    },
    async editFormValue(row, index) {
      // 保存当前编辑的索引
      this.editingIndex = index;
      this.isEditing = true;
      this.deptAttributeForm = JSON.parse(JSON.stringify(row));
      this.addDeptAttributeDialog = true;
    },
    async handleAddDeptAttribute() {
      try {
        await this.$refs.deptAttributeForm.validate();
      } catch (error) {
        this.$message.warning("请填写完整表单")
        return;
      }
      const attributeOption = this.selectKsOptions.find(opt => opt.id === this.deptAttributeForm.attributeCode);
      const newAttribute = {
        ...this.deptAttributeForm,
        attributeCode: attributeOption ? attributeOption.id : '',
        applyHospital: 0,
        deptId: 0
      };

      if (this.isEditing && this.editingIndex !== -1) {
        // 编辑模式：替换指定索引的数据
        this.$set(this.addDeptForm.departmentAttribute, this.editingIndex, newAttribute);
      } else {
        this.addDeptForm.departmentAttribute.push(newAttribute);
      }
      this.handleCloseAddDeptAttributeForm()
    },

    async getDeptList() {
      const res = await findAttribute({clinicId: this.userInfo.clinicId});
      this.$store.commit('preload/updatePreloadData', {
        key: 'getDeptListOptions',
        data: res.data.map(item => {
          return {
            id: item.id, label: item.deptName,
            specialtyCode: item.specialtyCode, specialtyName: item.specialtyName
          }
        })
      });
    },
    removeAttribute(index) {
      this.addDeptForm.departmentAttribute.splice(index, 1)
    },
    addAttribute() {

    },
    async handleAddDeptForm() {
      try {
        await this.$refs.addDeptForm.validate();
      } catch (error) {
        this.$message.error("系统异常:请联系管理员!!!");
        return;
      }
      this.addDeptForm.deptCode = this.$refs.deptCodeInput?.$el?.querySelector('input')?.value;
      this.addDeptForm.clinicId = this.userInfo.clinicId;
      this.addDeptForm.physicalPosition = JSON.stringify(this.physicalPositionArr);
      let res;
      if (this.addDeptForm.id === null) {
        res = await addDept(this.addDeptForm)
        if (res.code === 200) {
          await this.getDeptList();
          this.$message.success(res.message)
          this.handleCloseAddDeptForm();
          await this.loadData();
        } else {
          this.$message.error(res.message)
        }
      } else {
        res = await updateDept(this.addDeptForm)
        if (res.code === 200) {
          await this.getDeptList();
          this.$message.success(res.message)
          this.handleCloseAddDeptForm();
          await this.loadData();
        } else {
          this.$message.error(res.message)
        }
      }
    },
    handleCloseAddDeptForm() {
      this.addDeptForm = Object.assign({}, this.$options.data.call(this).addDeptForm);
      this.$refs.addDeptForm.resetFields();
      this.physicalPosition = '';
      this.physicalPositionArr = [];
      this.addDeptDialogVisible = false;
      this.showDeptDialogVisible = false;
    },

    handleCloseAddDeptAttributeForm() {
      this.deptAttributeForm = Object.assign({}, this.$options.data.call(this).deptAttributeForm);
      this.editingIndex = -1;
      this.isEditing = false;
      this.$refs.deptAttributeForm.resetFields();
      this.addDeptAttributeDialog = false;
    },
    /*
      数据源
    */
    async loadData() {
      let res = await getDeptList({
        deptName: this.queryConditionForm.deptName === '' ? null : this.queryConditionForm.deptName,
        status: this.queryConditionForm.status === '' ? null : this.queryConditionForm.status,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      });

      if (res.code === 200) {
        this.tableData = res.data.content.map(item => {
          // 确保status字段是字符串类型
          item.status = item.status ? item.status.toString() : '1';
          // 添加负责人姓名
          if (item.personInCharge && this.personInChargeMap[item.personInCharge]) {
            item.personInChargeName = this.personInChargeMap[item.personInCharge];
          }
          return item;
        });
        this.totalSize = res.data.totalSize || 0;
      }
    },
    initButtons() {
      // 获取当前路由路径
      const currentPath = this.$route.path;
      // 获取路由对应的权限按钮
      const routeButtons = this.$getRouteButtons(currentPath);
      console.log(routeButtons, 'routeButtonsrouteButtons');
      // 合并到现有按钮数组
      this.feetBtn = this.$mergeButtons(this.defaultButtons, routeButtons);
      // console.log(this.feetBtn,'this.feetBtnthis.feetBtn');
    },
    handleSuccess() {
      // 新增成功后的回调，可以刷新列表等操作
      this.fetchSupplierList();
    },
    async chooseStaff() {
      // 员工信息数据源
      let res = await yglist();
      this.fzrOptions = res.data.map(v => {
        return {label: v.fullName, value: v.id, ...v}
      });

      // 构建负责人ID到姓名的映射表
      this.personInChargeMap = {};
      this.fzrOptions.forEach(item => {
        this.personInChargeMap[item.id] = item.fullName;
      });

      // 更新表格数据中的负责人名称
      if (this.tableData && this.tableData.length > 0) {
        this.tableData = this.tableData.map(item => {
          if (item.personInCharge && this.personInChargeMap[item.personInCharge]) {
            item.personInChargeName = this.personInChargeMap[item.personInCharge];
          }
          return item;
        });
      }
    },
    // 用于计算table的高度，以便超出高度显示滚动条
    getTableHeight() {
      let headerHeight = this.currentHeight.mainHeight
      let feetHeight = this.currentHeight.feetHeight
      let lastHeight = this.currentHeight.lastHeight
      this.tableHeight = this.currentHeight.rightContentHeight - feetHeight * 3
      // console.log(this.tableHeight,'this.tableHeightthis.tableHeight');
    },
    // 其他原有方法保持不变...
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 888 * Math.random());
    },
    // 状态切换方法
    async toggleStatus(row) {
      try {
        const newStatus = row.status === '1' ? '2' : '1';
        const res = await updateSupplierEntity({
          id: row.id,
          status: newStatus
        });
        if (res.code === 200) {
          row.status = newStatus; // 更新本地状态
          this.$message({
            type: 'success',
            message: `状态已${newStatus === '1' ? '启用' : '禁用'}`
          });
          this.loading = false;
        } else {
          this.$message.error(res.message || '状态更新失败');
          this.loading = false;
        }
      } catch (error) {
        console.error('状态更新失败:', error);
        this.$message.error('状态更新失败');
      } finally {
        this.loading = false;
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.supplierName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.searchValue = item.supplierName
      this.loadData();
    },
    handleIconClick(ev) {
      this.loadData();
    },
    handleNodeClick(data) {
      this.treeValue = data.id;
      this.loadData();
    },
    handClickName(val) {
      console.log(val);
    },
    handleDelete(rowId) {
      console.log(rowId);
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let ress = await deleteDrugP({
          drugId: rowId
        })
        if (ress.code === 200) {
          this.$message({type: 'success', message: '已删除'});
          this.loadData();
        } else {
          this.$message.error(ress.message)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    saveEditData() {

    },
    columnWidth(col, list) {
      let prop = col.prop, lab = col.lab;
      let width = 20;
      let maxlenStr = "";
      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      return width + 12;

      function len(str) {
        let length = 0;
        for (const char of str + "") {
          if ("a" <= char && char <= "z") length += 12;
          else if ("A" <= char && char <= "Z") length += 12;
          else if (Number.isFinite(Number(char))) length += 12;
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 32;
          else length += 12;
        }
        return length;
      }
    },
    async handClick(i) {
      switch (i) {
        case 0:
          await this.loadData()
          break;
        case 1:
          this.addDeptDialogVisible = true;
          break;
      }
    },
    feetHandClick(v) {
      console.log(v);
      if (v.title == '新增' || v.title.includes('新增')) {
        // 处理索引2的逻辑 => 新增 -> 调用子组件
        let param = {
          nameTitle: '新增科室'
        }
        this.$refs.addDialog.open(param);
      }
      // 处理逻辑 => 修改
      else if (v.title == '修改' || v.title.includes('修改')) {
        // 处理索引1的逻辑 => 修改
        if (this.currentTable.length === 0) {
          this.$message({type: "warning", message: "请先选择一条要编辑的数据."});
        } else {
          this.loading = true;
          setTimeout(() => {
            let param = {
              id: this.currentTable.id,
              nameTitle: '修改科室',
              isShow: true,
              system: true,
            }
            this.loading = false;
            this.$refs.addDialog.open(param);
          }, 888)

        }
      }
      // 处理逻辑 => 删除
      else if (v.title == '删除') {
        // 处理索引2的逻辑 => 删除
        if (this.currentTable.length != 0) {
          this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let delId = this.currentTable[0].id;
            let res = await deldocMark({id: delId})
            if (res.code === 200) {
              setTimeout(() => {
                this.$message({type: 'success', message: '已删除'})
                this.loadData();
              }, 1888)
            } else {
              this.$message({type: 'error', message: 'fail！'})
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message({type: 'warning', message: '请先选择一条要删除的数据'});
        }
      }
      // 处理逻辑 => 查看
      else if (v.title == '查看') {
        // 处理索引查看的逻辑 => 查看
        if (this.currentTable.length === 0) {
          this.$message({type: "warning", message: "请先选择一条要查看的数据."});
        } else {
          this.loading = true;
          setTimeout(() => {
            let param = {
              id: this.currentTable.id,
              nameTitle: '查看',
              isShow: true,
              system: true,
            }
            this.loading = false;
            this.$refs.addDialog.open(param);
          }, 888)
        }
      }
      // 处理逻辑 => 打印
      else if (v.title === '打印') {
        this.handlePrint();
      }
      // 处理逻辑 => 导出
      else if (v.title === '导出') {
        this.$confirm('敬请期待')
            .then(_ => {
            })
            .catch(_ => {
            });
      }
      // 处理逻辑 => 关闭
      else {
        setTimeout(() => {
          window.history.back();
        }, 888)
      }

    },
    handleCurrentTableChange(val) {
      this.currentTable = val
    },
    handledbRow(row, column, event) {
      if (row) {
        this.loading = true;
        setTimeout(() => {
          let param = {
            id: row.id,
            label: '查看',
            isShow: false,
            system: true,
          }
          this.loading = false;
          this.$refs.addModel.openAddModel(param);
        }, 888)
      } else {
        this.$message({type: "info", message: "未知异常，请稍后重试！"});
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            this.formdisabled = true;
            this.loadData();
            done();
          })
          .catch(_ => {
            this.formdisabled = this.formdisabled;
          });
    },
    handleCommand(command) {
      switch (command) {
        case 'a':
          this.DropDownedName = '全部';
          this.queryConditionForm.status = '';
          break;
        case 'b':
          this.DropDownedName = '启用'
          this.queryConditionForm.status = '1';
          break;
        case 'c':
          this.DropDownedName = '禁用'
          this.queryConditionForm.status = '0';
          break;
      }
      this.loadData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 288;
    },
    //表格数据回显
    safeGetMappedValue(col, row) {
      // 1. 检查数据有效性
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      // 2. 检查映射数组
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      // 3. 执行映射
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 30; // 增加边距缓冲
      const contentList = tableData.map(item => item?.[prop] ?? '');

      // 计算所有内容宽度（包括表头）
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度（使用Canvas）
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column, $index}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5); //加上一个文字长度
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
  }
}
</script>


<style lang="less" scoped>
.form-card, .table-card {
  border: 1px solid #e6ebf5;
  border-radius: 4px;
  height: 500px; /* 设置固定高度 */
}

.form-card {
  overflow-y: auto; /* 内容超出时显示滚动条 */
}

.table-card {
  display: flex;
  flex-direction: column;
}

.table-card ::v-deep .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  overflow: hidden; /* 防止内容溢出 */
}

.table-card ::v-deep .el-table {
  flex: 1;
  overflow: auto; /* 表格内部滚动 */
}

/* 确保表格头和身体都能滚动 */
.table-card ::v-deep .el-table__body-wrapper,
.table-card ::v-deep .el-table__header-wrapper {
  overflow: auto;
}

.form-card, .table-card {
  border: 1px solid #e6ebf5;
  border-radius: 4px;
}

.form-card {
  overflow-y: auto;
}

.table-card {
  display: flex;
  flex-direction: column;
}

.table-card ::v-deep .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
}

.table-card ::v-deep .el-table {
  flex: 1;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 10px;
}

.el-card__header {
  background-color: #007bb0;
  padding: 5px 10px !important;
}

.form-layout {
  display: flex;
  gap: 20px;
}

.left-form {
  flex: 1;
}

.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 16px;
}

.custom-form-dialog .el-dialog__body {
  padding: 10px;
}

.el-divider {
  margin: 16px 0;
}

.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog {
  .showDialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }
}


// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

    .feetbtn {
      display: flex;
      justify-content: center;
      margin-left: 12px;
    }
  }

  // main
  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // height: 473px; /* 设置父容器的高度 */
    // overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {

      }
    }
  }

  // addModel
  .addModel {
    margin-left: 12px;

    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  .editModel {
    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  // feet
  .feet {
    padding: 12px;

  }

}
</style>